<template>
  <div id="app">
    <ShellHeader />
    <ShellMenu />
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import ShellHeader from '@/components/shell/header'
import ShellMenu from '@/components/shell/menu'
export default {
  components: {
    ShellHeader,
    ShellMenu,
  },
  created() {
    const userRole = localStorage.getItem('userRole')
    if (userRole) {
      this.setUserRole(userRole)
    }
  },
  methods: {
    ...mapMutations({
      setUserRole: 'setUserRole',
    }),
  },
}
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  position: relative;
}
</style>
